import { Avatar, Box, Button, Collapse, Stack, TextField, Typography } from "@mui/material"
import { useContext, useEffect, useRef, useState } from "react"
import moment from 'moment'

import EditIcon 		from '@mui/icons-material/Edit';
import DeleteIcon 		from '@mui/icons-material/Delete';

import AuthContext 		from "../../context/AuthProvider";
import ConfirmDialog 	from "../ConfirmDialog";

import ThreadReply 		from "./ThreadReply"
import { Link } from "react-router-dom";

const ForumThread = ({post, onPost, onDelete}) => {
	const {auth}										= useContext(AuthContext)

	const [isCommentsOpen, setIsCommentsOpen] 			= useState(false)
	const [isReplyOpen, setIsReplyOpen]					= useState(false)
	const [isDeleteConfirmOpen, setIsDeleteConfirmOpen]	= useState(false)
	const [selectedPostId, setSelectedPostId]			= useState()
	const [isEditing, setIsEditing]						= useState(false)
	const [isPosting, setIsPosting]						= useState(false)

	const [postText, setPostText]						= useState(post.text)
	const [reply, setReply]								= useState('')
	const replyRef										= useRef()

	const deletePost									= onDelete
	const savePost										= onPost

	useEffect(() => {
		if (auth?.userId) replyRef.current.focus()
	}, [isReplyOpen])

	useEffect(() => {
		if (isReplyOpen) {
			document.addEventListener('keydown', keydownHandler);
		}
		else {	
			document.removeEventListener('keydown', keydownHandler);
		}

		return () => {
			document.removeEventListener('keydown', keydownHandler);
		}	
	}, [reply])

	const keydownHandler = (e) => {
		if (e.key === 'Enter' && e.ctrlKey) handleReply(null, null, reply, post.companyId, post.id);
		if (e.key === 'Escape') handleCancel();			
	}

	const handleConfirmation = (id) => {
		setSelectedPostId(id)
		setIsDeleteConfirmOpen(true)
	}	

	const handleCancel = () => {
		setReply('')
		setIsEditing(false)
	}

	const handlePostSave = (postId, title, text, companyId, parentId) => {
		setIsPosting(true)
		savePost(postId, title, null, text, companyId, parentId)
		.then(() => {
			setIsEditing(false)
			setIsPosting(false)
		})
	}

	const handleReply = (postId, title, text, companyId, parentId) => {
		setIsPosting(true)
		savePost(postId, title, null, text, companyId, parentId)
		.then(() => {
			setIsReplyOpen(false)
			setIsCommentsOpen(true)
			setReply('')
			setIsPosting(false)
		})
	}

	return (
		<Box sx={{mt: 1}} width={'100%'} marginY={1} borderRadius={1} boxShadow={2}>

			{/* CONFIRMACAO DE REMOÇÃO DE REGISTRO */}
			<ConfirmDialog 
			title="Aviso"
			children="Tem certeza que deseja exluir o registro?"
			open={isDeleteConfirmOpen}
			setOpen={setIsDeleteConfirmOpen}
			onConfirm={() => deletePost(selectedPostId)}
			/>			

			{/* CABECALHO DO POST */}
			<Stack direction={'row'} padding={1} bgcolor={'#DCDCDC'} borderRadius={'4px 4px 0px 0px'} alignItems={'center'}>
				<Avatar/>
				<Stack direction={'column'} sx={{ml: 1}} flex={1}>
					<Typography sx={{fontWeight: 'bold'}}>{post.title}</Typography>
					<Typography sx={{fontSize: '0.75em'}}>Postado em <b>{postCategories[post.category]}</b></Typography>
					<Typography sx={{fontSize: '0.75em'}}>por @{post.user.username} em {moment(post.createdAt).format('DD/MM/YYYY HH:mm')}</Typography>
				</Stack>
				{auth.user === post.user.username ? (
					<>
						<EditIcon color="primary" onClick={() => setIsEditing(!isEditing)}/>
						<DeleteIcon color="primary" onClick={() => handleConfirmation(post.id)}/>				
					</>
				) : null }

				{post.company?.imageUrl ? (
					// <Box display={'flex'} sx={{backgroundColor: 'darkGray', marginLeft: 1, width: '60px', height:'60px', borderRadius: '30px'}} justifyContent={'center'} alignItems={'center'}>
					<img
						loading="lazy"
						height="50"
						width="50"
						src={post.company.imageUrl}
						srcSet={post.company.imageUrl}
						alt=""
						/>
					// </Box>
				) : null}

			</Stack>

			{/* CASO ESTEJA EDITANDO, MOSTRA OS CAMPOS PARA EDICAO, SENAO, MOSTRA O TEXTO */}
			{ isEditing ? (
				<Box sx={{p: 1}}>
					<TextField fullWidth multiline rows={4} value={postText} onChange={e => setPostText(e.target.value)}/>
					<Stack direction={'row'} width={'100%'} justifyContent={'right'} marginTop={1} spacing={1}>
						<Button variant="contained" color='secondary' onClick={handleCancel}>Cancelar</Button>
						<Button variant="contained" onClick={() => handlePostSave(post.id, post.title, postText, post.companyId, post.parentId)} disabled={isPosting}>Salvar</Button>
					</Stack>
				</Box>
			):(
				<Typography marginY={1} padding={1}>{postText}</Typography>
			)}

			{/* RENDERIZA AS RESPOSTAS */}
			<Collapse in={isCommentsOpen} sx={{pl: 4, pr:1}}>
				{ post.replies.length > 0 ? post.replies.map (r => (
					<ThreadReply key={r.id} reply={r} onPost={savePost} onDelete={deletePost}/>
				))
				: (
					<Typography align="center">Ainda não há nenhum comentário.</Typography>
				)}
			</Collapse>

			{/* RENDERIZA O FORMULARIO PARA RESPONDER O TOPICO */}
			<Collapse in={isReplyOpen} sx={{pl: 4, pr:1, pt: 2}}>
			{ auth?.userId ? (
				<Stack direction={'column'} justifyContent="space-between" alignItems="flex-end" spacing={1} marginTop={1}>
					<TextField fullWidth multiline rows={4} label={'Reposta'} value={reply} onChange={e => setReply(e.target.value)} inputRef={replyRef}/>
					<Button variant="contained" sx={{width: 100}} onClick={() => handleReply(null, null, reply, post.companyId, post.id)} disabled={isPosting}>Responder</Button>
				</Stack>
			) : (
				<Box sx={{height:100, marginTop: 1, display: 'flex', borderRadius: 1, boxShadow: 2, justifyContent: 'center', alignItems: 'center'}}>
					<Typography>Você precisa efetuar o login para postar! Clique <Link to={'/login'}>aqui</Link> para efetuar o login</Typography>
				</Box>
			)}
			</Collapse>

			{/* BOTOES DE CONTROLE */}
			<Stack direction={'row'} justifyContent={'right'} padding={1} spacing={1} marginTop={1}>
				<Button variant="contained" color={!isReplyOpen ? 'primary' : 'secondary'} onClick={() => setIsReplyOpen(!isReplyOpen)}>{ isReplyOpen ? 'Cancelar' : 'Responder'}</Button>		
				<Button variant="contained" onClick={() => setIsCommentsOpen(!isCommentsOpen)}>{ isCommentsOpen ? 'Esconder' : 'Ver '+ (post.replies.length > 1 ? post.replies.length : '')} Comentários</Button>		
			</Stack>
		</Box>
	)
}

const postCategories = {
	GENERAL 	: 'Investimentos em Geral',
	ACOES 		: 'Investimentos em Ações no Brasil',
	STOCKS 		: 'Investimentos em Ações no Exterior',
	COMPANY 	: 'Empresas',
	HELP 		: 'Ajuda / Suporte'
}

export default ForumThread